import { ButtonProps } from "antd";
import { StyledButton } from "./atom";

export function Button({ className = "", ...props }: ButtonProps) {
  return (
    <StyledButton
      className={`renderbus-ui--button ${className}`}
      {...props}
      onMouseLeave={(e: FocusEvent) => {
        e.target?.blur();
      }}
    />
  );
}
